import React__default from 'react';

const width = 20;
const height = 15;
const IconLineChart = ({ fill = "black", size = 1 }) => {
    return (React__default.createElement("svg", { width: size * width, height: size * height, viewBox: "0 0 20 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.9836 9.8818L5.99958 5.8928L0.0175781 13.0008L1.55458 14.2818L6.28158 8.6798L11.2966 12.6928L19.9906 1.8408L18.4286 0.591797L10.9836 9.8818Z", fill: fill })));
};

export { IconLineChart as default };
//# sourceMappingURL=IconLineChart.js.map
